import {SummaryType} from '@ls/grouping-service';
import {produce} from 'immer';
import { deleteDefinition } from 'state/grid/util';
import {COMMIT_SELECTIONS} from 'state/selections/actions';
import SelectionState from 'state/selections/SelectionState';
import {
  RECEIVE_GRID_DATA,
  RECEIVE_TRACE_ANALYTIC_VALUES,
  RECEIVE_TRACE_PERIOD_VALUES,
  REQUEST_GRID_DATA,
  REQUEST_TRACE_ANALYTIC_VALUES,
  REQUEST_TRACE_PERIOD_VALUES,
  SET_DEFINITION,
  SET_DEFINITIONS,
  DELETE_DEFINITION
} from './actions';

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
  traceTypeOptions: [
    {label: 'Global', value: 'global'},
    {label: 'Bucket', value: 'bucket'},
  ],
  fetchingTraceAnalyticValues: false,
  traceAnalyticValues: [],
  fetchingTracePeriodValues: false,
  tracePeriodValues: [],
  fetchingGridData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  gridData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
};

export default produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      const {definition, idx} = action;
      const selectedDefinitions = state.definitions[SelectionState.UNCOMMITTED];
      if (definition === null) {
        selectedDefinitions.splice(idx, 1);
      } else {
        selectedDefinitions[idx] = definition;
      }
      break;
    }

    case DELETE_DEFINITION:
      state.definitions = deleteDefinition(state.definitions, action.payload);
      break;
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      state.analyticsData = defaultState.analyticsData;
      state.definitions[SelectionState.COMMITTED] = state.definitions[SelectionState.UNCOMMITTED];
      break;
    }
    case REQUEST_TRACE_ANALYTIC_VALUES: {
      state.fetchingTraceAnalyticValues = true;
      break;
    }
    case RECEIVE_TRACE_ANALYTIC_VALUES: {
      state.fetchingTraceAnalyticValues = false;
      state.traceAnalyticValues = action.data;
      break;
    }
    case REQUEST_TRACE_PERIOD_VALUES: {
      state.fetchingTracePeriodValues = true;
      break;
    }
    case RECEIVE_TRACE_PERIOD_VALUES: {
      state.fetchingTracePeriodValues = false;
      state.tracePeriodValues = action.data;
      break;
    }
    case REQUEST_GRID_DATA: {
      state.fetchingGridData[action.summary] = true;
      state.gridData[action.summary] = defaultState.gridData[action.summary];
      break;
    }
    case RECEIVE_GRID_DATA: {
      state.fetchingGridData[action.summary] = false;
      state.gridData[action.summary] = action.data;
      break;
    }
    default:
      return state;
  }
});
